import { SvgIcon } from '@mui/material';

export function StampCheckmarkIcon(props) {
	return (
		<SvgIcon
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			{...props}
		>
			<path d="M7.16667 18.75L5.58334 16.0833L2.58334 15.4167L2.875 12.3333L0.833336 10L2.875 7.66667L2.58334 4.58333L5.58334 3.91667L7.16667 1.25L10 2.45833L12.8333 1.25L14.4167 3.91667L17.4167 4.58333L17.125 7.66667L19.1667 10L17.125 12.3333L17.4167 15.4167L14.4167 16.0833L12.8333 18.75L10 17.5417L7.16667 18.75ZM7.875 16.625L10 15.7083L12.1667 16.625L13.3333 14.625L15.625 14.0833L15.4167 11.75L16.9583 10L15.4167 8.20833L15.625 5.875L13.3333 5.375L12.125 3.375L10 4.29167L7.83334 3.375L6.66667 5.375L4.375 5.875L4.58334 8.20833L3.04167 10L4.58334 11.75L4.375 14.125L6.66667 14.625L7.875 16.625ZM9.125 12.9583L13.8333 8.25L12.6667 7.04167L9.125 10.5833L7.33334 8.83333L6.16667 10L9.125 12.9583Z" />
		</SvgIcon>
	);
}
